import { differenceInHours } from 'date-fns';

export const getDuration = (timeFrom: number | Date, timeTo: number | Date) => {
  return differenceInHours(timeTo, timeFrom);
};

export const formatHours = (hours: number) => {
  const forms = ['час', 'часа', 'часов'];
  let index;
  if (hours % 10 == 1 && hours % 100 != 11) {
    index = 0;
  } else if (hours % 10 >= 2 && hours % 10 <= 4 && (hours % 100 < 10 || hours % 100 >= 20)) {
    index = 1;
  } else {
    index = 2;
  }
  return `${hours} ${forms[index]}`;
};
